exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * Default, original theme\n */\n/**\n * Global\n */\n/**\n * InputField\n */\n/**\n * tooltip, also known as popOver\n */\n/**\n * arrayField\n */\n/**\n * select\n */\n/**\n * Icons\n */\n/**\n * selection-field\n */\n.array-field-add-message.field-item {\n  border: 0;\n  vertical-align: middle;\n  margin-left: .5em;\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/widgets/arrayField.scss
// module id = 94
// module chunks = 0